/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MobilePhoneRegular from './mobile-phone-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return (
        <MobilePhoneRegular
            {...validProps}
            color={validProps.color ? validProps.color : '#4D4540'}
        />
    );
}
SvgComponent.iconName = 'mobilePhoneRegular';

export const MobilePhoneRegularIcon = svgIconWrapper(SvgComponent);
